import { DiscoveredChannelEntity, selectionForImport, selectionForReject } from '../../../domain/entities/DiscoveredChannel';
import { DiscoveredChannelsQuery, IDiscoveredChannelRepository } from '../../ports/IDiscoveredChannelRepository';

export class ListDiscoveredChannelsUseCase {
  constructor(private repo: IDiscoveredChannelRepository) {}
  execute(query: DiscoveredChannelsQuery) {
    return this.repo.list(query);
  }
}

export class ImportDiscoveredChannelsUseCase {
  constructor(private repo: IDiscoveredChannelRepository) {}
  execute(channels: DiscoveredChannelEntity[]) {
    return this.repo.importToCatalog(selectionForImport(channels));
  }
}

export class RejectDiscoveredChannelsUseCase {
  constructor(private repo: IDiscoveredChannelRepository) {}
  execute(channels: DiscoveredChannelEntity[]) {
    return this.repo.reject(selectionForReject(channels));
  }
}
